import { ApiKey, BillingPortalResponse, Plan, CheckoutSessionResponse } from "../types/api";

const API_BASE_URL = "/api/v1"; // Always use relative URL to work with both dev proxy and production rewrites

export const apiService = {
  async fetchKeys(token: string): Promise<ApiKey[]> {
    const response = await fetch(`${API_BASE_URL}/keys`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch API keys");
    }

    return response.json();
  },

  async createKey(token: string, name: string): Promise<{ key: string }> {
    const response = await fetch(`${API_BASE_URL}/key`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name }),
    });

    if (!response.ok) {
      throw new Error("Failed to create API key");
    }

    return response.json();
  },

  async deleteKey(token: string, keyId: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/key/${keyId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to delete API key");
    }
  },

  // billing api

  async fetchPlans(): Promise<Plan[]> {
    const response = await fetch(`${API_BASE_URL}/plans`);
    if (!response.ok) {
      throw new Error("Failed to fetch plans");
    }

    return response.json();
  },

  async fetchUserPlan(token: string): Promise<Plan | null> {
    const response = await fetch(`${API_BASE_URL}/plans/me`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 404) {
      return null;
    }
    if (!response.ok) {
      throw new Error("Failed to fetch user plan");
    }

    return response.json();
  },

  async createCheckoutSession(token: string, priceId: string): Promise<CheckoutSessionResponse> {
    const response = await fetch(`${API_BASE_URL}/checkout/session`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ priceId }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Failed to create checkout session");
    }

    return response.json();
  },

  async createBillingPortalSession(token: string): Promise<BillingPortalResponse> {
    const response = await fetch(`${API_BASE_URL}/billing-portal`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Failed to create billing portal session");
    }

    return response.json();
  },
};
